import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

// GET
// /Api/Admin/Facility/FacilityData
export const getFacilityData = async () => {
  const response = await axios.get('/Admin/Facility/FacilityData');
  return response;
};

// POST
// /Api/Admin/Facility/FacilityForm
export const postFacilityForm = async ({ form, id, attachment }) => {
  const updatedForm = {
    Beds: form.beds,
    CompanyId: form.company?.value ?? 0,
    ParentFacilityId: form.parentFacility?.id,
    ParentFacilityCensusCategoryIds: form.parentFacilityCensusCategoryIds,
    FacilityName: form.facilityName,
    ShortName: form.shortName,
    Abbreviation: form.abbreviation,
    StreetAddress: form.streetAddress,
    City: form.city,
    State: form.state,
    Zip: form.zip,
    County: form.county,
    PhoneNumber: form.phoneNumber,
    TaxExempt: form.taxExempt,
    FacStructure: form.facStructure,
    ApPhone: form.apPhone,
    EINNumber: form.EIN,
    InvoiceEmail: form.invoiceEmail,
    RepName: form.repName,
    RepEmail: form.repEmail,
    PayMethod: form.payMethod,
    logo: form.logo,
  };

  if (id) {
    updatedForm.Id = id;
  }
  if (attachment) {
    updatedForm.SiteMapFile = attachment.path;
  }

  const formData = objectToFormData({
    ...updatedForm,
    attachment,
  });

  const response = await axios.post('Admin/Facility/FacilityForm', formData, attachment);
  return response;
};

// POST
// /Api/Admin/Facility/DeleteFacility id
export const postDeleteFacility = async (id) => {
  const response = await axios.post(`/Admin/Facility/DeleteFacility?id=${id}`);
  return response;
};

// GET
// /Api/Admin/Facility/DownloadFacilities
////Download Api is used in code bec we need the `${HOST_API_URL}

// GET
// /Api/Admin/Facility/BookingVendorAccountsData id
export const getBookingVendorAccountsData = async (facilityId) => {
  const response = await axios.get(`/Admin/Facility/BookingVendorAccountsData?facilityId=${facilityId}`);
  return response;
};

// POST
// /Api/Admin/Facility/UpdateFacilityBookingType facilityId typeId
export const postUpdateFacilityBookingType = async (facilityId, typeId, account, subaccount) => {
  const response = await axios.post(
    `/Admin/Facility/UpdateFacilityBookingType?facilityId=${facilityId}&typeId=${typeId}&account=${account}&subaccount=${subaccount}`
  );
  return response;
};

// POST
// /Api/Admin/Facility/DeleteFacilityBookingVendorAccount
export const postDeleteFacilityBookingVendorAccount = async (id) => {
  const response = await axios.post(`/Admin/Facility/DeleteFacilityBookingVendorAccount?id=${id}`);
  return response;
};

// POST
// /Api/Admin/Facility/FacilityBookingAccountForm
export const postFacilityBookingAccountForm = async (form) => {
  const response = await axios.post('Admin/Facility/FacilityBookingAccountForm', objectToFormData(form));
  return response;
};

// POST
// /Api/Admin/Facility/CopyFacilityVendorBookingAccounts copyFrom copyTo
export const postCopyFacilityVendorBookingAccounts = async (copyFrom, copyTo) => {
  const response = await axios.post(
    `/Admin/Facility/CopyFacilityVendorBookingAccounts?copyFrom=${copyFrom}&copyTo=${copyTo}`
  );
  return response;
};

// POST
// /Api/Admin/Facility/UpdateFacilityExtraField facilityId type value
export const postUpdateFacilityExtraField = async (facilityId, value, type) => {
  const response = await axios.post(
    `/Admin/Facility/UpdateFacilityExtraField?facilityId=${facilityId}&type=${type}&value=${value}`
  );
  return response;
};

// POST
// /Api/Admin/Facility/APContactForm facilityId email id
export const postAPContactForm = async (facilityId, email, id) => {
  const updatedForm = {
    FacilityId: facilityId,
    Email: email,
  };

  if (id) {
    updatedForm.Id = id;
  }

  const formData = objectToFormData({
    ...updatedForm,
  });

  const response = await axios.post('Admin/Facility/APContactForm', formData);
  return response;
};

// GET/Api/OrderReviewers; facilityId
export async function getOrderReviewers(facilityId) {
  const response = await axios.get(`Admin/Facility/OrderReviewers?facilityId=${facilityId}`);
  return response;
}

// POST Api/Admin/Facility/DeleteFacilityContact id
export async function deleteFacilityContact(id) {
  const response = await axios.post(`Admin/Facility/DeleteFacilityContact?id=${id}`);
  return response;
}

// GET Api/Admin/Facility/FacilityOrderContacts facilityId
export async function getFacilityOrderContacts(facilityId) {
  const response = await axios.get(`Admin/Facility/FacilityOrderContacts?facilityId=${facilityId}`);
  return response;
}

// POST Api/Admin/Facility/FacilityOrderContactForm
export async function postFacilityOrderContactForm(form, facilityId, id) {
  const updatedForm = {
    Id: id ?? 0,
    FacilityId: facilityId,
    FirstName: form.firstName,
    LastName: form.lastName,
    Position: form.position,
    Email: form.email,
    Phone: form.phone,
    Cell: form.cell,
    CcOnOrderEmails: form.ccOnOrderEmails,
  };
  const response = await axios.post('Admin/Facility/FacilityOrderContactForm', objectToFormData(updatedForm));
  return response;
}

// POST Api/Admin/Facility/UpdateFacilityOrderContactCc id ccOnOrderEmails
export async function postUpdateFacilityOrderContactCc(id, ccOnOrderEmails) {
  const response = await axios.post(
    `Admin/Facility/UpdateFacilityOrderContactCc?id=${id}&ccOnOrderEmails=${ccOnOrderEmails}`
  );
  return response;
}

// POST Api/Admin/Facility/DeleteFacilityOrderContact id
export async function postDeleteFacilityOrderContact(id) {
  const response = await axios.post(`Admin/Facility/DeleteFacilityOrderContact?id=${id}`);
  return response;
}

// POST Api/Admin/Facility/GetRequiredReviewPreference facilityId, preference
export async function getRequiredReviewPreference(facilityId) {
  const response = await axios.get(`Admin/Facility/GetRequiredReviewPreference?facilityId=${facilityId}`);
  return response;
}
export async function postRequiredReviewPreference(facilityId, preference) {
  const response = await axios.post(`Admin/Facility/RequiredReviewPreference`, objectToFormData({ facilityId, preference }));

  return response;
}

// POST
// /Api/Admin/Facility/ReviewerForm
export const postReviewerForm = async (input, facilityId) => {
  const response = await axios.post('Admin/Facility/OrderReviewerForm', objectToFormData({ facilityId, ...input }));
  return response;
};

// POST
// /Api/Admin/Facility/FacilityUserReviewerForm
export const postFacilityUserReviewerForm = async (form, facilityId) => {
  const updatedForm = {
    FacilityId: facilityId,
    Reviewers: form.reviewers,
    Email: form?.email,
  };

  const formData = objectToFormData({ ...updatedForm});

  const response = await axios.post('Admin/Facility/FacilityUserReviewerForm', formData);
  return response;
};
